/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_setToPairs.js
// module id = 106
// module chunks = 28313394369846 114276838955818 211641130022272